import { useQuery } from '@tanstack/react-query';
import { fetchStopActivities, type StopActivitiesParams } from '@apis/reports';

/**
 * Read the activities scheduled on a floor for the given date. Cache key is
 * intentionally keyed on (site, floor, date) — independent of any specific
 * stop — so multiple stops on the same floor share one fetch.
 */
export function useStopActivitiesQuery(params: StopActivitiesParams) {
  return useQuery({
    queryKey: [
      'reports',
      'daily-route',
      'activities',
      params.siteId,
      params.floorId,
      params.date,
    ],
    queryFn: ({ signal }) => fetchStopActivities(params, signal),
    enabled: !!params.siteId && !!params.floorId && !!params.date,
    staleTime: 5 * 60 * 1000,
  });
}
